<template>
	<div>
		<Header />
		<Carousel v-model="value" loop :height="400" arrow="never" dots="none">
			<CarouselItem>
				<div class="banner"
					:style="{'background': 'url('+require('@/assets/img/tableEntryService/caseBanner.jpg')+') center center no-repeat'}">
					<div>
						<p class="pageType_">数品案例库</p>
						<p>内置海量行业案例库，涵盖不同数据类型的产品结构</p>
						<div class="suAssistant">
							<img :src="require('@/assets/img/tableEntryService/suHalf.png')" alt="" />
							<div>
								<p>我是数据产品设计智能助手；</p>
								<p>只需输入数据资源描述与应用场景，</p>
								<p>即可基于案例库匹配相似模板，自动生成数据产品。</p>

								<router-link tag="button" class="buttonFill" to="/dataProductDesign">
									立即设计我的数据产品
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</CarouselItem>
		</Carousel>
		<div class="mainContent">
			<div class="types">
				<div>
					<span class="typesName">行业领域：</span>
					<ul>
						<li v-for="(item,i) in industryField" :class="{'typeActive':industryIdx==i}"
							@click="typesSearch(i,'industryIdx')" v-if="item">
							{{item}}
						</li>
					</ul>
				</div>

				<div>
					<span class="typesName">数据产品类型：</span>
					<ul>
						<li v-for="(item,i) in dataProductType" :class="{'typeActive':productTypeIdx==i}"
							@click="typesSearch(i,'productTypeIdx')" v-if="item">
							{{item}}
						</li>
					</ul>
				</div>

				<div>
					<span class="typesName">数据产品来源：</span>
					<ul>
						<li v-for="(item,i) in productSource" :class="{'typeActive':sourceIdx==i}"
							@click="typesSearch(i,'sourceIdx')" v-if="item">
							{{item}}
						</li>
					</ul>
				</div>
			</div>


			<ul class="subject">
				<li v-for="(item,i) in account" :key="i" :class="{'active':selectedIdx==i}" @click="switchover(i)">
					{{item.name}}
				</li>
			</ul>

			<div style="text-align: right;margin: 0 0 30px;display: flex;justify-content: flex-end;">
				<Input search size="large" placeholder="搜索关键词" v-model="productKeyWord" @on-change="change(productKeyWord)"
					style="width: 300px;" />
			</div>

			<div>

				<!-- <Table border :columns="productColumns" :data="productData"></Table> -->

				<ul class="caseList" v-if="selectedIdx==0">
					<li v-for="(item,i) in productData" :key="i">
						<div class="name">
							<span class="content-tit">{{item.productName}}</span>
							<span class="index_type">{{item.productType}}</span>
						</div>

						<p class="index_desc">{{item.productIntroduction}}</p>

						<p class="orgName">{{item.orgName}}</p>

						<router-link tag="div" class="index_detailbtn"
							:to="{ path: '/caseProduct', query: { id:item.id } }">查看详情</router-link>
					</li>
				</ul>

				<ul class="caseList" v-else>
					<li v-for="(item,i) in productData" :key="i">
						<div class="name">
							<span class="content-tit">{{item.assetsName}}</span>
							<span class="index_type">{{item.source}}</span>
						</div>

						<p class="index_desc">{{item.assetsDescription}}</p>

						<p class="orgName">{{item.orgName}}</p>

						<router-link tag="div" class="index_detailbtn"
							:to="{ path: '/caseRegister', query: { id:item.id } }">查看详情</router-link>
					</li>
				</ul>


				<div class="showElevator">
					<Page id="pageId" :current="currentPageNumber" :total="total" :page-size="pageSize" prev-text="上一页"
						next-text="下一页" @on-change="pageChange" show-total />
				</div>
			</div>


		</div>


		<SignUp />
		<Footer />
	</div>
</template>

<script>
	import Header from '../../common/header/flow_header.vue'
	import Footer from '../../common/footer.vue'
	import publicMethod from '../publicMethod'
	import SignUp from '@/components/signUp/index.vue'

	import qs from 'qs'

	import {
		merge
	} from 'lodash'

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			SignUp
		},
		data() {
			return {
				url: this.domain.testUrl + this.domain.valuationProject,
				pageSize: 5,
				currentPageNumber: 1,
				total: 0,
				productKeyWord: '',
				value: 0,
				account: [{
					name: '产品列表',
					type: 1
				}, {
					name: '登记列表',
					type: 2
				}],
				selectedIdx: 0,
				productData: [{
					productName: '产品1',
					productType: 'AAA',
					orgName: '北京你好',
					productIntroduction: '介绍介绍介绍介绍'
				}, {
					productName: '产品1',
					productType: 'AAA',
					orgName: '北京你好',
					productIntroduction: '介绍介绍介绍介绍'
				}],
				industryIdx: 0,
				industryField: [],
				productTypeIdx: 0,
				dataProductType: [],
				sourceIdx: 0,
				productSource: []

			}
		},
		mounted() {

			if (this.$route.query.index) {
				this.selectedIdx = Number(this.$route.query.index)
			}

			this.getProductSearchInfo(this.selectedIdx)

			this.getList()
		},
		methods: {
			switchover(i) {
				this.selectedIdx = i
				this.productKeyWord = ''
				this.currentPageNumber = 1

				this.industryIdx = 0
				this.productTypeIdx = 0
				this.sourceIdx = 0

				this.$router.push({
					query: merge({}, this.$route.query, {
						index: i
					})
				})
				this.getProductSearchInfo(this.selectedIdx)
				this.getList()
			},
			pageChange(value) {
				this.currentPageNumber = value
				this.getList()
			},
			change(value) {
				this.productKeyWord = value
				this.getList()
			},
			getList() {
				if (this.selectedIdx == 0) {
					this.getDataProductList()
				} else {
					this.getDataRegistrationList()
				}

			},
			getDataProductList() {
				this.$post(this.url + 'dataProductExchange/getDataProductList', qs.stringify({
						pageNum: this.currentPageNumber,
						pageSize: this.pageSize,
						keyWord: this.productKeyWord,
						industry: this.industryField[this.industryIdx] != '全部' ? this.industryField[this.industryIdx] : '',
						productType: this.dataProductType[this.productTypeIdx] != '全部' ? this.dataProductType[this
							.productTypeIdx] : '',
						source: this.productSource[this.sourceIdx] != '全部' ? this.productSource[this.sourceIdx] : ''
					}))
					.then(res => {
						this.productData = res.data.content.records
						this.total = res.data.content.total
					})

			},
			getDataRegistrationList() {
				this.$post(this.url + 'dataRegistrationExchange/getDataRegistrationList', qs.stringify({
						pageNum: this.currentPageNumber,
						pageSize: this.pageSize,
						keyWord: this.productKeyWord,
						industry: this.industryField[this.industryIdx] != '全部' ? this.industryField[this.industryIdx] : '',
						productType: this.dataProductType[this.productTypeIdx] != '全部' ? this.dataProductType[this
							.productTypeIdx] : '',
						source: this.productSource[this.sourceIdx] != '全部' ? this.productSource[this.sourceIdx] : ''
					}))
					.then(res => {
						this.productData = res.data.content.records
						this.total = res.data.content.total
					})

			},
			typesSearch(idx, idxName) {
				this[idxName] = idx;

				if (this.selectedIdx == 0) {
					this.getDataProductList()
				} else {
					this.getDataRegistrationList()
				}
			},
			getProductSearchInfo(idx) {
				var method = idx === 1 ? 'dataRegistrationExchange/getRegistrationSearchInfo' :
					'dataProductExchange/getProductSearchInfo'

				this.$post(this.url + method, qs.stringify({}))
					.then(res => {
						this.industryField = res.data.content.productIndustry
						this.dataProductType = res.data.content.productType
						this.productSource = res.data.content.productSource

						this.industryField.unshift('全部')
						this.dataProductType.unshift('全部')
						this.productSource.unshift('全部')

					})
			}




		}


	}
</script>

<style scoped lang="less">
	.pageType_ {
		font-size: 41px;
		color: #282828;
		font-weight: bold;
		padding-bottom: 10px;
		margin-bottom: 15px;
		position: relative;
	}

	.pageType_::after {
		content: '';
		display: block;
		width: 460px;
		height: 2px;
		background: #282828;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.pageType_+p {
		font-size: 20px;
		color: #282828;
		margin-bottom: 187px;
	}

	.suAssistant {
		display: flex;
		position: absolute;
		bottom: 0;

		>img {
			width: 172px;
		}

		>div {
			height: 184px;
			padding: 20px 25px;
			background: rgba(255, 255, 255, .5);
			border-radius: 20px;
			position: relative;
			top: 20px;
			margin-left: 10px;

			p {
				font-size: 16px;
				margin-bottom: 5px;
				color: #282828;
			}

			.buttonFill {
				border-radius: 22.5px;
			}
		}

		>div::before {
			content: "";
			position: absolute;
			width: 0;
			height: 0;
			border-top: 20px solid transparent;
			/* 顶部边框透明 */
			border-bottom: 20px solid transparent;
			/* 底部边框透明 */
			border-right: 20px solid rgba(255, 255, 255, .5);
			/* 右边边框为蓝色，创建三角形 */
			left: -20px;
			/* 根据需要调整位置 */
			top: 50%;
			transform: translateY(-50%);
		}
	}


	.mainContent {
		margin-top: 75px;
	}

	.partitionRule {
		font-size: 28px;
		font-weight: bold;
		color: #282828;
		text-align: center;
		margin-bottom: 40px;
	}

	/deep/ .ivu-table {
		font-size: 14px;
	}

	.subject {
		display: flex;
		gap: 0 50px;

		li {
			font-size: 20px;
			font-weight: bold;
			color: #282828;
			cursor: pointer;
		}

		li.active {
			color: var(--mainColor);
		}
	}

	.caseList {
		li {
			height: 182px;
			padding: 20px 5px 20px 20px;
			border: 2px solid #FFFFFF;
			box-shadow: 2px 2px 13px 0px rgba(32, 76, 151, 0.23);
			overflow: hidden;
			cursor: pointer;
			margin-bottom: 30px;
			position: relative;

			.name {
				display: flex;
				align-items: center;
				width: 100%;
				margin-bottom: 18px;
			}

			.content-tit {
				max-width: 900px;
				font-size: 18px;
				font-weight: bold;
				color: #282828;
				margin-right: 20px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.index_type {
				height: 24px;
				line-height: 24px;
				text-align: center;
				padding: 0 10px;
				background: #f4f6f9;
				border: 1px solid #e5e6eb;
				color: #282828;
			}

			.index_desc {
				width: 70%;
				line-height: 22px;
				font-size: 14px;
				color: #666666;
				text-align: justify;
				margin-bottom: 10px;
				-webkit-line-clamp: 2;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.orgName {
				font-size: 14px;
				color: #999999;
				position: absolute;
				bottom: 20px;
				left: 20px;
			}

			.index_detailbtn {
				width: 142px;
				height: 36px;
				line-height: 36px;
				background: var(--mainColor);
				font-size: 14px;
				color: #FFF;
				text-align: center;
				cursor: pointer;
				position: absolute;
				right: 20px;
				top: 50%;
				transform: translateY(-50%);
			}

		}

	}

	.types {
		border-bottom: 1px solid #ccc;
		margin-bottom: 50px;

		.typesName {
			width: 150px;
			line-height: 35px;
			font-size: 18px;
			color: #282828;
			display: block;
			font-weight: bold;
		}

		>div {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			margin-bottom: 25px;

			ul {
				width: calc(100% - 150px);
				display: flex;
				flex-wrap: wrap;
				gap: 10px 20px;

				li {
					font-size: 18px;
					color: #282828;
					padding: 3px 15px;
					cursor: pointer;
					border-radius: 5px;
					border: 1px solid transparent;
				}

				li.typeActive {
					border-color: var(--mainColor);
				}
			}

		}
	}
</style>